import { render, staticRenderFns } from "./GruposLayout.vue?vue&type=template&id=4fa0197f&scoped=true"
import script from "./GruposLayout.vue?vue&type=script&lang=js"
export * from "./GruposLayout.vue?vue&type=script&lang=js"
import style0 from "./GruposLayout.vue?vue&type=style&index=0&id=4fa0197f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0197f",
  null
  
)

export default component.exports